module.exports = __webpack_public_path__ + "static/media/Mienshao_gaussian2.7eae028d.png";